import "core-js/modules/es.string.trim.js";
import i18n from 'i18next';
import config from 'utils/config';
import truncateText from 'utils/ui/truncateText';
import { getUrlServiceHref } from 'utils/getUrlServiceHref';
/**
 * Labels longer than this number of characters will
 * be cropped on mobile and only displayed as a tooltip
 * on desktop
 */
export var CUSTOM_LINK_LABEL_SOFT_CHAR_LIMIT = 10;
function getNavigationLinks() {
  var _customNavBarLink$tit;
  var navLinks = [{
    title: i18n.t('navbar_home'),
    link: '/home',
    icon: 'home'
  }, {
    title: i18n.t('navbar_profile'),
    link: '/profile',
    icon: 'user'
  }, {
    title: i18n.t('navbar_browse'),
    link: '/browse',
    icon: 'topic'
  }];
  var customNavBarLink = config.customNavBarLink;
  var hasCustomNavBarLink = (customNavBarLink === null || customNavBarLink === void 0 ? void 0 : (_customNavBarLink$tit = customNavBarLink.title) === null || _customNavBarLink$tit === void 0 ? void 0 : _customNavBarLink$tit.trim()) && customNavBarLink.url;
  if (hasCustomNavBarLink) {
    navLinks.push({
      title: truncateText(customNavBarLink.title, CUSTOM_LINK_LABEL_SOFT_CHAR_LIMIT) || '',
      href: getUrlServiceHref(customNavBarLink.url) || '',
      icon: 'external',
      hideOnDesktop: true
    });
  }
  return navLinks;
}
export function getCustomNavbarLink() {
  var _customNavBarLink$tit2;
  var customNavBarLink = config.customNavBarLink;
  var enabled = !!(customNavBarLink !== null && customNavBarLink !== void 0 && (_customNavBarLink$tit2 = customNavBarLink.title) !== null && _customNavBarLink$tit2 !== void 0 && _customNavBarLink$tit2.trim() && customNavBarLink !== null && customNavBarLink !== void 0 && customNavBarLink.url);
  return {
    enabled: enabled,
    title: (customNavBarLink === null || customNavBarLink === void 0 ? void 0 : customNavBarLink.title) || '',
    url: getUrlServiceHref(customNavBarLink === null || customNavBarLink === void 0 ? void 0 : customNavBarLink.url) || ''
  };
}
export default getNavigationLinks;